export default "__VITE_ASSET__BcR6Itxu__"